import styled from 'styled-components'

export const ContainerPluginStyled = styled.div`
  padding: 10px;
`
